import { render, staticRenderFns } from "./CouponDetails.vue?vue&type=template&id=644dc2e0&scoped=true&"
import script from "./CouponDetails.vue?vue&type=script&lang=js&"
export * from "./CouponDetails.vue?vue&type=script&lang=js&"
import style0 from "./CouponDetails.vue?vue&type=style&index=0&id=644dc2e0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644dc2e0",
  null
  
)

export default component.exports